var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFacebookLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8951_12242)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.2749 7.07067L12.9851 9.08511H9.50466V16.1356H7.3895V9.08511H4.21675V7.07067H7.3895V5.22444C7.3895 2.66309 9.04144 1.00721 11.5997 1.00721C12.6954 1.00721 13.3786 1.06262 13.773 1.11297L13.7424 3.02065L12.1158 3.02367C12.0714 3.01964 11.0117 2.94108 10.2471 3.60987C9.75425 4.03996 9.50466 4.65838 9.50466 5.44604V7.07068H13.2749V7.07067ZM10.9567 4.35622C11.3734 3.98657 12.0227 4.02686 12.0703 4.02887L14.7841 4.02787L14.8423 0.300152L14.434 0.204464C14.1718 0.143036 13.3691 0 11.5997 0C8.44919 0 6.33191 2.10005 6.33191 5.22444V6.06346H3.15918V10.0923H6.33191V17.1429H10.5622V10.0923H13.9063L14.4869 6.06346H10.5622V5.44603C10.5622 4.95552 10.6955 4.58888 10.9567 4.35622Z",
    fill: "#2D2C2B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8951_12242"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 17.1429,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebookLogo);
export default __webpack_public_path__ + "static/media/Facebook_logo.70143fec110ca8dcb1dfe369c833cb55.svg";
export { ForwardRef as ReactComponent };